import React, { useState, useEffect } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams, useSearchParams } from "react-router-dom";
import { SidebarProvider } from "../../Context/SidebarContext";
import MetaData from "../../components/layout/MetaData";

import {
  useGetperentDetailsQuery,
  useGetSubCategoryDetailsQuery,
} from "../../redux/api/categoryApi";

import {
  useGetAttributesValuesQuery,
  useGetProductsQuery,
} from "../../redux/api/productsApi.js";

import BodyContent from "../Products/BodyContent";
import InlineAttributesFilter from "../Category/InlineAttributesFilter";
import Loader from "../../components/Loader";
import CategoryNav from "../Products/CategoryNav";
import ProductsTable from "../Products/ProductsTable";
import CustomPagination from "../../components/layout/CustomPagination";

import ResultsShownFilter from "../Products/ResultsShownFilter";
// import CustomPagination from "../../components/layout/CustomPagination";

/**
 * 展示分类详情、属性筛选和分类商品列表。
 * @returns {JSX.Element} 分类详情页
 */
const CategoryDetails = () => {
  const { id } = useParams();
  let [searchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;
  const select = Number(searchParams.get("select"));
  const keyword = searchParams.get("keyword") || "";

  const [data, setData] = useState();
  const [options, setOptions] = useState({});
  const { data: parentCategoryDetails, isLoading: isLoadingParent } = useGetperentDetailsQuery(id);
  const { data: subCategoryDetails, isLoading: isLoadingSub } = useGetSubCategoryDetailsQuery(id);
  
  // Get All Attributes Values
  const parentName = parentCategoryDetails?.parentCategory?.name;
  const subName = subCategoryDetails?.category?.name;
  const categoryName = parentName || subName;
  const { data: values, isLoading: isLoadingValues } = useGetAttributesValuesQuery(categoryName || skipToken);
  const res = values?.data?.category;
  const params = {
    page,
    keyword,
    select,
    category:
    parentCategoryDetails?.parentCategory?.name ,
    sup_category: subCategoryDetails?.category?.name,
    product_Attributes:JSON.stringify(options),
  };
  
  const {
    data: products,
    isLoading: isLoadingProducts,
  } = useGetProductsQuery(params);
  
  // console.log("options", options);

  useEffect(() => {
    if (parentCategoryDetails) {
      
      setData(parentCategoryDetails);
    } else {
      setData(subCategoryDetails);
    }
  }, [parentCategoryDetails, subCategoryDetails]);

  if (isLoadingParent || isLoadingSub || isLoadingProducts) return <Loader />;

  return (
    <SidebarProvider>
      <>
        <MetaData title="Category Details" />
        <main className="px-[50px] md:px-[100px] bg-[#F5F9FF]">
          <CategoryNav />
          <article className="w-full min-h-[70vh] flex flex-col">
            <section className="flex flex-col flex-1 shrink-0 min-w-0">
              <BodyContent data={data} />
              <InlineAttributesFilter
                setOptions={setOptions}
                selectedOptions={options}
                isLoadingValues={isLoadingValues}
                parentAttributes={res}
              />
              <ResultsShownFilter
                filteredProductsCount={products?.totalCount}
                resPerPage={products?.paginationResult}
              />
              {isLoadingProducts ? (
                <i>Loading...</i>
              ) : (
                <ProductsTable products={products?.data} />
              )}

              <CustomPagination
                resPerPage={products?.paginationResult}
                results={products?.results}
                filteredProductsCount={products?.totalCount}
              />
            </section>
          </article>
        </main>
      </>
    </SidebarProvider>
  );
};

export default CategoryDetails;
